import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { ActionLink } from 'components/shared';

import { useModalToast } from './ModalToast/useModalToast';
import ModalToast from './ModalToast/ModalToast';

/**
 * @deprecated Use { Modal } from `@companycam/slab-web` instead
 *
 * https://slab-web.cocam.co/?path=/docs/modal--docs
 */

const Modal = ({
  isOpen,
  onRequestClose,
  label,
  isClosable,
  title,
  className,
  children,
  style,
}) => {
  const { toast } = useModalToast();

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      contentLabel={label}
      overlayClassName="modal"
      className={className}
      style={style}
    >
      {isClosable ? (
        <ActionLink className="modal-close-button" onClick={onRequestClose}>
          <i className="mdi mdi-close" />
        </ActionLink>
      ) : null}
      {toast ? (
        <ModalToast
          type={toast.type}
          message={toast.message}
          actionMessage={toast.actionMessage}
          onActionPress={toast.onActionPress}
          toastDuration={toast.toastDuration}
        />
      ) : null}

      {!!title && <h3 className="modal-title">{title}</h3>}

      {children}
    </ReactModal>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  label: PropTypes.string,
  isClosable: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

Modal.defaultProps = {
  isOpen: false,
  onRequestClose: () => {},
  label: 'Modal Content',
  isClosable: true,
  className: 'modal-content-wrap',
};

export default Modal;
